import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Hyperlink } from "@ebsco-ui/ebsco-ui";

import { PUA_UPDATE_PATH } from "../../../../constants";
import sharedMessages from "../../../../shared-messages";
import SuccessIndicator from "../../success-indicator";
import messages from "./reset-success-indicator-messages";

import "./reset-success-indicator.scss";

const block = "reset-success-indicator";

const ResetSuccessIndicator = () => {
  const { formatMessage } = useIntl();
  const signInUrl =
    useSelector(state => state.navigation.returnUrl) || PUA_UPDATE_PATH;

  return (
    <SuccessIndicator
      className={block}
      title={formatMessage(messages.passwordReset)}
    >
      <p className={`${block}__description`}>
        {formatMessage(messages.signInToContinue)}
      </p>
      <Hyperlink
        href={signInUrl}
        styleType="highlighted"
        target="_self"
        className={`${block}__link`}
      >
        {formatMessage(sharedMessages.signIn)}
      </Hyperlink>
    </SuccessIndicator>
  );
};

export default ResetSuccessIndicator;
